// 企业信息
const CompanyInfoRouter = {
  path: 'companyInfo',
  name: 'CompanyInfo',
  meta: {
    requiresAuth: false,
    leftMenu: true
  },
  component: () => import('@/views/Setting/companyInfo')
}
export default CompanyInfoRouter
